<!-- <h2 mat-dialog-title>{{title}}</h2> -->
<mat-dialog-content class="mat-typography">
  <p>{{textToAgree}}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button color="warn" [mat-dialog-close]="false"><mat-icon>cancel</mat-icon></button>
  <button mat-raised-button color="primary" [mat-dialog-close]="true" cdkFocusInitial><mat-icon>check</mat-icon>{{title}}</button>
</mat-dialog-actions>
